import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from '@material-ui/icons/Delete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { selectEasymsRates } from '../../../../../selectors/hostelworldSelectors/hwEasymsSelector'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    expansionPanelCell: {
        padding: 0
    },
    expansionPanel: {
        boxShadow: 'none',
        background: 'transparent'
    },
    expansionPanelSummary: {
        margin: 0
    },
    expansionPanelDetails: {
        padding: 0
    },
    remoteNameTableRow: {
        height: '20px'
    }
})

class RatesTable extends Component {
    handleDelete = ourId => () => {
        const toastrConfirmOptions = {
            onOk: () => this.props.onDelete(ourId)
        }
        toastr.confirm('Вы уверены, что хотите удалить тариф?', toastrConfirmOptions)
    }

    render() {
        const { classes, rates = [] } = this.props

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID организации</TableCell>
                            <TableCell>Тариф EasyMS</TableCell>
                            <TableCell>Тарифы Hostelworld.com</TableCell>
                            <TableCell padding="checkbox" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rates.map(item => (
                            <TableRow hover key={item.ourId}>
                                <TableCell>{item.organizationId}</TableCell>
                                <TableCell>{item.ourId}</TableCell>
                                <TableCell className={classes.expansionPanelCell}>
                                    <ExpansionPanel className={classes.expansionPanel}>
                                        <ExpansionPanelSummary
                                            className={classes.expansionPanelSummary}
                                            expandIcon={<ExpandMoreIcon />}
                                        >
                                            <span>Категории и тарифы</span>
                                            <em style={{ marginLeft: '4px', color: 'grey' }}>(развернуть)</em>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className={classes.remoteNameTableRow}>
                                                        <TableCell>ID категории</TableCell>
                                                        <TableCell>ID тарифа</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {Object.keys(item.remoteRates).map(itemKey => (
                                                        <TableRow className={classes.remoteNameTableRow} key={itemKey}>
                                                            <TableCell>{itemKey}</TableCell>
                                                            <TableCell>{item.remoteRates[itemKey]}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                </TableCell>
                                <TableCell padding="none">
                                    <IconButton
                                        title="Delete"
                                        aria-label="Delete"
                                        onClick={this.handleDelete(item.ourId)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

RatesTable.propTypes = {
    classes: PropTypes.object.isRequired,
    rates: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired
}

export default connect(state => ({
    easymsRates: selectEasymsRates(state)
}))(withStyles(styles)(RatesTable))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/RatesTab/RatesTable.js